import { render, staticRenderFns } from "./LayoutGrupoForm.vue?vue&type=template&id=29d48215"
import script from "./LayoutGrupoForm.vue?vue&type=script&lang=js"
export * from "./LayoutGrupoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports